// removed by extract-text-webpack-plugin
module.exports = {"container":"src-page-components-search----styles-module---container---BGddx","header":"src-page-components-search----styles-module---header---3aaeh","content":"src-page-components-search----styles-module---content---2oh3x","textAndButton":"src-page-components-search----styles-module---textAndButton---3rw0o","glassResults":"src-page-components-search----styles-module---glassResults---3xPwi","memoryResults":"src-page-components-search----styles-module---memoryResults---1uCV2"};


//////////////////
// WEBPACK FOOTER
// ./src/page-components/search/styles.module.css
// module id = 659
// module chunks = 142807904292071